import React from "react"

import Layout from "../components/Layout"
import BlogList from "../components/sections/BlogList"
import PageHeader from "../components/sections/PageHeader"
import Contact from "../components/sections/Contact"

const Projetos = ({ location }) => {
  return (
    <Layout location={location} seo={{ title: "Blog" }}>
      <PageHeader title={`Blog`} size={`sm`} />
      <BlogList />
      <Contact variant={`sm`} />
    </Layout>
  )
}

export default Projetos
